import { MODAL_ACTION_TYPES } from 'store/actions/modal.actions';

const initialState = {
  modal: '',
  isShow: false,
  options: {},
};

function commonModalReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case MODAL_ACTION_TYPES.MODAL_SHOW_MODAL:
      return { ...state, ...payload };
    case MODAL_ACTION_TYPES.MODAL_HIDE_MODAL:
      return { ...state, modal: '', isShow: false };
    default:
      return state;
  }
}

export default commonModalReducer;
